import React, { useState } from "react";
import UserAvatar from "@/components/user/UserAvatar";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "@/components/Component";
import { LinkList } from "@/components/links/Links";
import { Link } from "react-router-dom";
import { useTheme, useThemeUpdate } from "@/layout/provider/Theme";
import { useAuth0 } from "@auth0/auth0-react";

const User = () => {
  const theme = useTheme();
  const themeUpdate = useThemeUpdate();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);

  const { user, isAuthenticated, logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin, // send back to app root after logout
      },
    });
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span>
                {isAuthenticated && user?.name
                  ? user.name.charAt(0).toUpperCase()
                  : "AB"}
              </span>
            </div>
            <div className="user-info">
              <span className="lead-text">
                {isAuthenticated && user?.name ? user.name : "Guest User"}
              </span>
            </div>
            <div className="user-action" onClick={() => setOpen(false)}>
              <Link to={`/user-profile-setting`} className="btn btn-icon me-n2">
                <Icon name="setting"></Icon>
              </Link>
            </div>
          </div>
        </div>

        {isAuthenticated && (
          <div className="dropdown-inner">
            <LinkList>
              <li>
                <a
                  href="#logout"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <Icon name="signout"></Icon>
                  <span>Sign Out</span>
                </a>
              </li>
            </LinkList>
          </div>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;